<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <wbo-entity-sub-group-by-report-criteria></wbo-entity-sub-group-by-report-criteria>
            </fui-row>
            <fui-row>
                <wbo-inventory-report-selection></wbo-inventory-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
